import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../Fotter";
import endPoint from "../redux/EndPoint/endpoint";
import { useNavigate } from "react-router-dom";
import bharatcodlogo from "../assets/Logo.png";

const AllOrders = () => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const isReSeller = role === "reSeller";

  const goToHome = () => {
    isReSeller
      ? (window.location.href =
          "https://play.google.com/store/apps/details?id=com.bharatcod&hl=en")
      : navigate("/");
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16647750621');
      `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]',
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full text-center relative transform transition-all duration-300 scale-100">
        <button
          onClick={goToHome}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl font-bold"
        >
          ❌
        </button>

        <div className="flex justify-center mb-4">
          <img
            src={bharatcodlogo}
            alt="App Logo"
            className="w-24 h-24 object-contain"
          />
        </div>

        <h2 className="text-2xl font-extrabold mb-2 text-gray-800">
          Track Your Order Easily!
        </h2>

        <p className="text-gray-600 mb-6 text-sm">
          Download our app now to get real-time updates and manage your orders
          effortlessly.
        </p>

        <a
          href="https://play.google.com/store/apps/details?id=com.bharatcod&hl=en"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 font-semibold transition-all"
        >
          Download App
        </a>
      </div>
    </div>
  );
};

export default AllOrders;
